module.exports = __webpack_public_path__ + "workOut.svg?8bafd9a5ebb7a4bacab0ed16353d62b3";